<template>
  <div>
    <v-container fluid>
      <div>
        <v-card class="login-card elevation-8 mb-4">
          <div class="card-header">
            <div class="header-icon">
              <v-icon size="32" color="white">mdi-lock-reset</v-icon>
            </div>
            <h2 class="header-title">Recuperar Senhas</h2>
          </div>
          <v-card-text class="pa-6">
            <v-text-field
              v-model="cpf"
              label="Informe seu CPF"
              required
              outlined
              class="custom-input"
              prepend-inner-icon="mdi-card-account-details"
              maxlength="14"
              placeholder="000.000.000-00"
              @input="formatarCpf"
            />
            <v-btn @click="recuperar" color="primary" class="validate-btn elevation-4 mt-4" block large>
              <v-icon left>mdi-email-send</v-icon>
              Recuperar Senha
            </v-btn>
            <v-btn @click="irParaAlterarSenha" color="secondary" class="validate-btn elevation-4 mt-2" block large>
              <v-icon left>mdi-key</v-icon>
              Já tenho a chave
            </v-btn>
            <v-alert v-if="msg" :type="msgType" class="mt-4" dense>
              {{ msg }}
            </v-alert>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center">
          <v-progress-circular indeterminate color="white" size="40" class="mb-4" />
          <span>Aguarde...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CredenciamentoServices from "@/services/acesso/CredenciamentoServices";
import { mapMutations } from "vuex";
export default {
  name: "RecuperarSenha",
  data: () => ({
    cpf: "",
    msg: "",
    msgType: "info",
    loading: false,
  }),
  methods: {
    ...mapMutations({ setMsnSetSenha: "login/setMsnSetSenha" }),
    formatarCpf(e) {
      let v = e.replace(/\D/g, "").slice(0, 11);
      if (v.length <= 3) {
        this.cpf = v;
      } else if (v.length <= 6) {
        this.cpf = v.replace(/(\d{3})(\d+)/, "$1.$2");
      } else if (v.length <= 9) {
        this.cpf = v.replace(/(\d{3})(\d{3})(\d+)/, "$1.$2.$3");
      } else {
        this.cpf = v.replace(/(\d{3})(\d{3})(\d{3})(\d+)/, "$1.$2.$3-$4");
      }
    },
    async recuperar() {
      const cpfLimpo = this.cpf.replace(/\D/g, "");
      if (!cpfLimpo || cpfLimpo.length !== 11) {
        this.msg = "CPF inválido. Informe um CPF válido.";
        this.msgType = "error";
        return;
      }
      this.loading = true;
      try {
        // se cpfLimpo for menor que 11 caraceter mensagem erro e return null para não enviar
        if (cpfLimpo.length < 11) {
          this.msg = "CPF inválido. Informe um CPF válido.";
          this.msgType = "error";
          this.loading = false;
          return;
        }
        const response = await CredenciamentoServices.solicitarKeyResetSenha({ cpf: cpfLimpo });

        if (response.success && response.success.includes("Operação realizada com sucesso")) {
          this.setMsnSetSenha(response.data);
          this.$router.push({ name: "AlterarSenha" });
        } else {
          this.msg = response.message || "Não foi possível enviar o e-mail com a chave de validação de nova senha.";
          this.msgType = "error";
        }
      } catch (e) {
        this.msg = "Erro ao tentar recuperar senha. Tente novamente mais tarde.";
        this.msgType = "error";
      } finally {
        this.loading = false;
      }
    },
    irParaAlterarSenha() {
      this.$router.push({ name: "AlterarSenha" });
    },
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.$router.push({ name: "homeMain" }); // HomeAvaliacao.vue agora é o componente da rota 'homeAvaliacao'
      return;
    }
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #efebe9 0%, #bcaaa4 100%);
  min-height: 100vh;
  padding: 24px 16px;
}
.min-height-screen {
  min-height: calc(100vh - 48px);
}
.main-wrapper {
  animation: fadeInUp 0.8s ease-out;
}
.login-card {
  border-radius: 16px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  overflow: hidden;
  animation: slideInUp 0.6s ease-out 0.2s both;
}
.card-header {
  background: linear-gradient(135deg, #ffccbc 0%, #d84315 100%);
  padding: 24px;
  text-align: center;
  position: relative;
}
.header-icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 16px;
}
.header-title {
  position: relative;
  z-index: 1;
  color: white;
  font-weight: 300;
  margin: 0;
}
.custom-input {
  margin-bottom: 16px;
}
.validate-btn {
  border-radius: 8px !important;
  height: 48px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>
